import React, { useLayoutEffect, useRef, useState } from 'react';
import { StatusTip } from 'tea-component';
import useIntls from '@opm/hooks/useIntls';
import { IContentSummary } from '@opm/services/competitorsAdCreatives';
import './index.scss';
import BubbleCommon from '@op/components/BubbleCommon';

export interface IAiContentCellProps {
  summaryList?: IContentSummary[];
  labelKey: string;
  loading?: boolean;
  noDataText?: string;
}

export default function AiContentCell({
  summaryList,
  labelKey,
  loading,
  noDataText = 'Unable to generate a summary for this video.',
}: IAiContentCellProps) {
  const { intl, isEn } = useIntls();
  const [expanded, setExpanded] = useState(false);
  const [isClamped, setIsClamped] = useState(false);
  const textRef = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    if (loading) return;
    const el = textRef.current;
    if (el) {
      setIsClamped(el.offsetHeight < el.scrollHeight);
    }
  }, [loading, summaryList, labelKey, expanded, isEn]);

  if (loading) {
    return (
      <div className="dbom-ai-content-cell dbom-ai-content-cell--loading">
        <StatusTip status="loading" loadingText="" />
      </div>
    );
  }

  if (!summaryList || summaryList.length === 0) {
    return (
      <div className="dbom-ai-content-cell dbom-ai-content-cell--empty">
        {intl(noDataText)}
      </div>
    );
  }

  const item = summaryList.find(
    (s) => s.label_en?.toLowerCase() === labelKey.toLowerCase(),
  );

  if (!item || (!item.summary_en && !item.summary_zh)) {
    return (
      <div className="dbom-ai-content-cell dbom-ai-content-cell--empty">
        {intl(noDataText)}
      </div>
    );
  }

  const text = isEn ? (item.summary_en || item.summary_zh) : (item.summary_zh || item.summary_en);

  return (
    <div
      className={`dbom-ai-content-cell ${expanded ? 'dbom-ai-content-cell--expanded' : ''}`}
    >
      <BubbleCommon showIcon={false} tipsMap={null} content={text}  placement='top'>
        <div className="dbom-ai-content-cell__text" ref={textRef}>{text}</div>
      </BubbleCommon>
      {/* {(isClamped || expanded) && (
        <span
          className="dbom-ai-content-cell__toggle"
          onClick={(e) => {
            e.stopPropagation();
            setExpanded(!expanded);
          }}
        >
          {intl(expanded ? 'Collapse' : 'Show More')}
        </span>
      )} */}
    </div>
  );
}
